import { DialogFooter } from '@src/design-system/dialog';
import { useRef, useState } from 'react';
import { Button } from '@src/design-system/button';
import { useFormikContext } from 'formik';
import { MembersList } from '@src/shared/components/members-list';
import type { TMember } from '@shared/types/member';
import interviewerApi from '@src/features/participants/services/interviewer-api';

const AddingMemberAsInterviewer = ({
  withFullHeight = false,
}: {
  withFullHeight?: boolean;
}) => {
  const closeRef = useRef<HTMLDivElement>(null);
  const [selectedMember, setSelectedMember] = useState<TMember | null>(null);

  const { mutate: createInterviewer, isPending } = interviewerApi.useCreate();
  const { setFieldValue } = useFormikContext();

  const createInterviewerFromMember = () => {
    if (!selectedMember) return;
    const name =
      selectedMember.user?.first_name + ' ' + selectedMember.user?.last_name;
    createInterviewer(
      {
        name,
        email: selectedMember.user?.email || '',
        job_title: selectedMember.job_title || '',
        company_name: selectedMember.organization?.name || '',
        type: 'MEMBER',
        member: selectedMember.id,
      },
      {
        onSuccess: (data) => {
          setFieldValue('host', data);
          closeRef.current?.click();
        },
      }
    );
  };

  return (
    <>
      <MembersList
        isItemSelected={(member) => member.id === selectedMember?.id}
        props={{
          infiniteListProps: {
            query: { exclude_interviewers: true },
            ...(withFullHeight && {
              props: { listContainerProps: { className: 'max-h-full' } },
            }),
          },
          infoItemProps: {
            withCheckbox: false,
          },
        }}
        onClickItem={(member) => setSelectedMember(member)}
      />
      <DialogFooter className='mt-auto'>
        <Button
          isLoading={isPending}
          className='flex-1'
          onClick={createInterviewerFromMember}
        >
          Add as Interviewer
        </Button>
      </DialogFooter>
    </>
  );
};

export default AddingMemberAsInterviewer;
